import axios from 'src/app-axios';
import Constants from 'src/constants';

export const alert = {
  namespaced: true,
  state: {
    message: '',
    type: '',
    timesheetAlert: false,
  },
  getters: {
    getTimesheetAlert (state) {
      return state.timesheetAlert;
    },
  },
  actions: {
    onAlert (context, alert) {
      context.commit('addAlert', alert);
    },
    async sendAlertResponse ({ dispatch }, payload) {
      const url = `api/devices/alerts/responses/${payload.responseId}`;
      try {
        await axios.post(url, payload.responseGiven);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your response.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async showTimesheetAlert ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/checkin-alerts`;
      try {
        const res = await axios.get(url);
        commit('setTimesheetAlert', res.data[0]);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in checking last timesheet',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async clickDataAnalytics ({ dispatch }, payload) {
      const url = `api/devices/install-reports`;
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your response.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
  },
  mutations: {
    addAlert (state, alert) {
      state.message = alert.message;
      state.type = alert.type;
    },
    setTimesheetAlert (state, data) {
      state.timesheetAlert = data;
    },
  },
};
